import axios from "axios";
import Config from "src/config";

// Envio de template pelo chat. O canal é identificado por `sessao` (o objeto `chat` do
// painel não carrega o canal_id), então data = { sessao, templateId, psid, parametros }.
const v1_actionMessengerEnviarTemplateChat = (clienteId, data) => {
    return axios({
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/${clienteId}/canais/messenger/templates/enviar`,
        data
    });
};

export default v1_actionMessengerEnviarTemplateChat;
